<div class="content" [innerHTML]="content?.body | safe:'html'"></div>
